const HeadersVisits = [
  { text: "ID Pedido", value: "request_id", sortable: false, show: true, groupable: false},
  { text: "Tipo", value: "visit_type.id", sortable: false, show: true, groupable: false },
  {
    text: "Estado",
    value: "visit_status",
    groupable: false,
    sortable: false,
    show: true
  },
  { text: "Cliente", value: "client", show: true, groupable: false, sortable: false },
  { text: "Servicio", value: "service_name", show: true, groupable: false, sortable: false },
  { text: "Fecha", value: "visit_date", show: true, sortable: false, groupable: true },
  {
    text: "Desde",
    value: "arrival_time",
    sortable: false,
    groupable: false,
    show: true
  },
  {
    text: "Hasta",
    value: "departure_time",
    sortable: false,
    groupable: false,
    show: true
  }
];

export default HeadersVisits;
